/**
 * KFT-4026 demo fix: Typesense's real "locations" collection returns `name`
 * as a locale-keyed object ({ de_DE, en_US }), not the plain string
 * SearchEngineLocation declares (Algolia's name is already a plain string, so this
 * is a no-op there). A proper per-document locations mapper (also covering
 * the _geoloc shape difference) is tracked as a KFT-4023 follow-up; this only
 * unblocks the location filter label.
 */
export const toTypesenseLocaleKey = (locale: string): string => {
  const [lang, country] = locale.split('-')
  return country ? `${lang}_${country.toUpperCase()}` : (lang ?? locale)
}

export const resolveLocalizedName = (name: unknown, locale: string): string => {
  if (typeof name === 'string') return name
  if (name && typeof name === 'object') {
    const byLocale = name as Record<string, string>
    return (
      byLocale[toTypesenseLocaleKey(locale)] ?? Object.values(byLocale)[0] ?? ''
    )
  }
  return ''
}
